import { render, staticRenderFns } from "./Cmedia.vue?vue&type=template&id=655b0160&scoped=true&"
import script from "./Cmedia.vue?vue&type=script&lang=js&"
export * from "./Cmedia.vue?vue&type=script&lang=js&"
import style0 from "./Cmedia.vue?vue&type=style&index=0&id=655b0160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b0160",
  null
  
)

export default component.exports